import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="w-full px-4 md:px-8 py-24 md:py-32 text-center">
      <p className="font-heading text-6xl md:text-8xl font-bold text-primary-200 select-none">
        404
      </p>
      <h1 className="mt-4 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
        页面走失了
      </h1>
      <p className="mt-3 text-sm md:text-base text-foreground-600">
        你访问的页面不存在，也许它已经搬去了别的地方。
      </p>
      <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-5 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-home-line"></i>
          返回首页
        </Link>
        <Link
          to="/category"
          className="inline-flex items-center gap-2 px-5 py-3 rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-film-line"></i>
          浏览电影分类
        </Link>
      </div>
    </div>
  );
}